<template>
  <div>
    <CHeader
      data-aos="fade-down"
      data-aos-easing="linear"
      data-aos-duration="1500"
    >
      <CHeaderBrand class="mx-auto" to="/">
        <img
          src="../assets/img/pickiddologolargesizewhite.png"
          height="48px"
          class="m-2"
        />
      </CHeaderBrand>

      <CDropdown color="light" class="m-2 d-sm-flex d-md-none" :caret="false">
        <template #toggler-content>
          <CIcon name="cil-justify-center" />
        </template>
        <!-- <CDropdownItem
          style="width: 100% !important"
          href="https://pickiddo.com/about"
        >
          ABOUT US</CDropdownItem
        >
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
        <CDropdownItem href="https://pickiddo.com/Tuition/UserGuide"
          >TUTORIAL</CDropdownItem
        > -->
        <CDropdownItem to="/Package">PRICING</CDropdownItem>
        <CDropdownItem to="/Partner">JOIN AS PARTNER</CDropdownItem>
        <CDropdownItem to="/SearchTutor">
          <CButton color="danger" size="sm" shape="pill"
            >REGISTER</CButton
          ></CDropdownItem
        >
      </CDropdown>

      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3"> </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/"> HOMEPAGE </CHeaderNavLink>
        </CHeaderNavItem>
        <!-- <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/about" exact>
            ABOUT US
          </CHeaderNavLink>
        </CHeaderNavItem> -->
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Package">
            PRICING
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink style="color: #fff" to="/Partner">
            JOIN AS PARTNER
          </CHeaderNavLink>
        </CHeaderNavItem>
        <CHeaderNavItem class="px-3 ml-3">
          <CHeaderNavLink to="/SearchTutor">
            <CButton color="danger" size="sm" shape="pill"
              >REGISTER</CButton
            ></CHeaderNavLink
          >
        </CHeaderNavItem>
      </CHeaderNav>
    </CHeader>

    <CJumbotron style="background: #e6ecf6">
      <CRow>
        <CCol
          sm="7"
          lg="7"
          style="margin-bottom: 10%"
          class="element-50 mt-5 text-left custom-center-pro"
        >
          <div>
            <h2
              style="font-weight: 700; margin-top: 10%; color: #2ea5b8"
              class="custom-title-tutor text-black ml-5"
            >
              <b>How can we help you?</b>
            </h2>

              <CInput type="text" size="lg" placeholder="Search your keyword" class="ml-5"/>
          </div>
        </CCol>
        <CCol sm="5" lg="5" class="element-50 mt-5 d-sm-down-none">
          <img
            style="max-width: 100%; max-height: 300px"
            src="../assets/img/support.png"
          />
        </CCol>
      </CRow>
    </CJumbotron>
    <CCol sm="12" lg="12">
      <CContainer>
        <CCard class="d-md-none mb-0" style="background: none; border: none">
          <CRow class="m-3">
            <CCol sm="4" lg="4">
              <CCard>
                <img
                  style="max-height: 200px"
                  src="../assets/img/vectorFaq.png"
                />
                <h5 class="text-center mt-4">FAQ</h5>
              </CCard>
            </CCol>
            <CCol sm="4" lg="4">
              <CCard>
                <img
                  style="max-height: 200px"
                  src="../assets/img/vectorGuide.jpg"
                />
                <h5 class="text-center mt-4">GUIDE</h5></CCard
              >
            </CCol>
            <CCol sm="4" lg="4">
              <CCard>
                <img
                  style="max-height: 200px"
                  src="../assets/img/vectorcontact.jpg"
                />
                <h5 class="text-center mt-4">SUPPORT</h5>
              </CCard>
            </CCol>
          </CRow>
        </CCard>

        <CCard
          style="margin-top: -150px; background: none; border: none"
          class="d-sm-down-none"
        >
          <CRow class="m-3">
            <CCol sm="4" lg="4">
              <CCard class="custom-hover">
                <CButton @click="GoToPageFaq()">
                  <img
                    style="max-width: 100%;x"
                    src="../assets/img/vectorFaq.png"
                  />
                  <h5 class="text-center mt-4">FAQ</h5>
                </CButton>
              </CCard>
            </CCol>
            <CCol sm="4" lg="4">
              <CCard class="custom-hover">
                <CButton>
                  <img
                    style="max-width: 100%;"
                    src="../assets/img/vectorGuide.jpg"
                  />
                  <h5 class="text-center mt-4">GUIDE</h5>
                </CButton></CCard
              >
            </CCol>
            <CCol sm="4" lg="4">
              <CCard class="custom-hover">
                <CButton @click="GotoWhatsap">
                  <img
                    style="max-width: 100%;"
                    src="../assets/img/vectorcontact.jpg"
                  />
                  <h5 class="text-center mt-4">SUPPORT</h5>
                </CButton>
              </CCard>
            </CCol>
          </CRow>
        </CCard>
      </CContainer>
    </CCol>

    <CCol sm="12" lg="12">
      <CContainer>
        <h2 class="text-center custom-font mt-5">
          <strong>Help by Categories</strong>
        </h2>
        <div class="ant-divider ant-divider-horizontal" role="separator"></div>

        <CRow>
          <CCol sm="4" lg="4">
            <CCard class="p-2">
              <div>
                <h5 class="custom-font mt-2">
                  <b>1. Getting Started</b>
                </h5>
                <p class="mt-4">What is Pickiddo ?</p>
                <p>Where can i download Pickiddo App ?</p>
                <p>How to register ?</p>
              </div>
              <div class="text-center">
                <CHeaderNavLink to="/GettingStarted"> View to See More > </CHeaderNavLink>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4" lg="4">
            <CCard class="p-2">
              <div>
                <h5 class="custom-font mt-2">
                  <b>2. Account & Settings</b>
                </h5>
                <p class="mt-4">How do I update my personal information ?</p>
                <p>How I can register my children in pickiddo ?</p>
                <p>How limit children I can register ?</p>
              </div>
              <div class="text-center">
                <CHeaderNavLink to="/AccountSetting"> View to See More > </CHeaderNavLink>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4" lg="4">
            <CCard class="p-2">
              <div>
                <h5 class="custom-font mt-2">
                  <b>3. Plans</b>
                </h5>
                <p class="mt-4">What package pickiddo have ?</p>
                <p>How I can subscribe package provided ?</p>
                <p>Can I subscribe package more than one ?</p>
              </div>
              <div class="text-center">
                <CHeaderNavLink to="/Plan"> View to See More > </CHeaderNavLink>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4" lg="4">
            <CCard class="p-2">
              <div>
                <h5 class="custom-font mt-2">
                  <b>4. Features</b>
                </h5>
                <p class="mt-4">What feature pickiddo provided ?</p>
                <p>Can I get all the feature ?</p>
                <p>Does teacher have their own Feature ?</p>
              </div>
              <div class="text-center">
                <CHeaderNavLink to="/Feature"> View to See More > </CHeaderNavLink>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4" lg="4">
            <CCard class="p-2">
              <div>
                <h5 class="custom-font mt-2">
                  <b>5. Fee and Payment</b>
                </h5>
                <p class="mt-4">How the payment can be made ?</p>
                <p>How about Fee of using pickiddo ?</p>
                <p>Where can i get slip of payment ?</p>
              </div>
              <div class="text-center">
                <CHeaderNavLink to="/"> View to See More > </CHeaderNavLink>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4" lg="4">
            <CCard class="p-2">
              <div>
                <h5 class="custom-font mt-2">
                  <b>6. Deactivate Account</b>
                </h5>
                <p class="mt-4">How I want to deactivate my account ?</p>
                <p>How about charge when I deactivate ?</p>
                <p>After deactivate,If I want to use back ?</p>
              </div>
              <div class="text-center">
                <CHeaderNavLink to="/"> View to See More > </CHeaderNavLink>
              </div>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
      <br /><br />
    </CCol>
    <div style="background: #f1efef">
      <CContainer>
        <CCol sm="12" lg="12" class="p-5">
          <CRow>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">PREFACE</h5>
              <br />
              <label class="custom-font"
                >Pickiddo is a platform to manage online tuition by providing
                on-demand tuition services to those who want to learn from the
                best teachers anywhere in the world interactively. It has
                leading-edge features that can speed up the job matching process
                and it's powered by A.I.</label
              >
              <a href="https://www.facebook.com/pickiddo">
                <img width="30px" src="../assets/img/fb1.png" />
              </a>
              <a href="https://twitter.com/pickiddo?lang=en">
                <img width="30px" class="ml-1" src="../assets/img/tw.png" />
              </a>
              <a href="https://www.instagram.com/pickiddo/?hl=en">
                <img width="30px" class="ml-1" src="../assets/img/in.png" />
              </a>
              <br /><br />
            </CCol>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">
                <strong> COMPANY </strong>
              </h5>
              <br />
              <a>
                <CHeaderNavLink to="/About">
                  <h6 class="text-black custom-font">
                    ABOUT US
                  </h6></CHeaderNavLink
                >
              </a>
              <br />
              <a>
                <CHeaderNavLink to="/Contact">
                  <h6 class="text-black custom-font">
                    CONTACT US
                  </h6></CHeaderNavLink
                >
              </a>
              <br />
              <!-- <a href="https://pickiddo.com/Blog"
                ><h6 class="text-black custom-font">BLOG</h6></a
              > -->
              <br /><br />
            </CCol>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">
                <strong>COMMUNITY</strong>
              </h5>
              <br />
              <a href="https://www.facebook.com/pickiddo"
                ><h6 class="text-black custom-font">FACEBOOK</h6></a
              >
              <br />
              <a href="https://twitter.com/pickiddo?lang=en">
                <h6
                  class="text-black custom-font"
                  href="https://twitter.com/pickiddo?lang=en"
                >
                  TWITTER
                </h6>
              </a>
              <br />
              <a href="https://www.instagram.com/pickiddo/?hl=en">
                <h6 class="text-black custom-font">INSTAGRAM</h6>
              </a>
              <br /><br />
            </CCol>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">
                <strong>TERM PRIVACY</strong>
              </h5>
              <br />
              <a>
                <CHeaderNavLink to="/Legal">
                  <h6 class="text-black custom-font">TERMS AND CONDITION</h6></CHeaderNavLink
                >
              </a>
            </CCol>
          </CRow>
        </CCol>
      </CContainer>
    </div>
  </div>
</template>

 
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import backgroundCounter from "../assets/img/bgmap.png";
import backgroundUrlApps from "../assets/img/bg3Copy-1.png";
import backgroundCount from "../assets/img/Landingpage.png";

import video from "../assets/img/register.mp4";
import video2 from "../assets/img/register1.mp4";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import _ from "lodash";

export default {
  name: "Login",
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      successModal: false,
      CustomerName: "",
      CustomerEmail: "",
      CustomerPhoneNumber: "",

      backgroundCounter,
      backgroundCount,
      backgroundUrlApps,
      view: {
        topOfPage: true,
      },

      video,
      video2,

      slides: 7,
      autoplay: true,
      loop: true,
      playerOptions: {
        loop: true,
        autoplay: true,
      },
      playerOption: {},
      autoplay: {
        // automatically play the video
        type: Boolean,
        default: () => true,
      },
      loop: {
        // loop the video infinitely
        type: Boolean,
        default: () => true,
      },
      cardList: false,
      toggle: false,
      SelectedGrade: "",
      grades: [],

      Name: "",
      PhoneNumber: "",
      successModal: false,

      faqs: [],
      answerFaq: {},
      ShowButton: false,
    };
  },
  created() {
    AOS.init();
  },
  async mounted() {
    this.GetGrade();
    this.GetQuestion();
    await this.GetAnswerFaq();
  },
  methods: {
    GoToPageFaq() {
      this.$router.push("/Faq");
    },
    GotoWhatsap() {
      location.replace(
        "https://wa.me/600106597700?text=+Hi, I would like to ask about pickiddo "
      );
    },
   
    toggles: function (item) {
      item.isActive = !item.isActive;
    },
   
    navbarShow() {
      this.cardList = true;
    },
    GoToPagePro() {
      this.$router.push("/ProClass");
    },
    GotoLogin() {
      this.$router.push("https://pickiddo.com/TuitionCenter/Login");
    },
    GotoApple() {
      this.$router.push("https://apps.apple.com/my/app/pickiddo/id1366167288");
    },
    GotoGoogle() {
      this.$router.push(
        "https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
      );
    },

    ShowButtonSubmit() {
      this.ShowButton = true;
    },
  },
};
</script>

<style>
body {
  background: #fff;
  font-family: "Rubik", sans-serif;
}
.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000015;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

.custom-font {
  font-family: "Rubik", sans-serif;
}

.change_color {
  background-color: red;
}

* {
  padding: 0;
  margin: 0;
}

body {
  height: 100vh;
}
body nav {
  position: fixed;
  width: 100%;
  height: 70px;
  background-color: transparent;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}
body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}

.c-header {
  background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83;
  /* color: #fff; */
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1em;
  line-height: 1.5;
  border-radius: 0.3rem;
}
.item-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 120%;
  margin-bottom: 10px;
  font-weight: 500;
  color: #4a4a4a;
}

.item-desc {
  font-size: 14px;
  line-height: 140%;
  min-height: 60px;
}

.card .custom-hover:hover{
     transition: .15s all ease-in-out;
      transform: scale(1.1);
      z-index: 100;
      background-color: #fff;
}

@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap");
</style>
